import React, { useContext, useCallback, useState, useRef, useEffect } from 'react';
import { BuildingContext } from '../../context/BuildingContext';
import BuildingControlsLeft from './BuildingControlsLeft';
import BuildingControlsRight from './BuildingControlsRight';
import '../../styles/components/ControlCenter.css';

const ControlCenter = React.memo(() => {
  const { state, dispatch } = useContext(BuildingContext);
  const [activeColorField, setActiveColorField] = useState(null);
  const colorPickerRef = useRef(null);

  // General handler for input changes
  const handleChange = useCallback((field) => (e) => {
    const value = e.target.type === 'number' ? parseInt(e.target.value) : e.target.value;
    dispatch({ field, value });
  }, [dispatch]);

  // Handler for color changes
  const handleColorChange = useCallback((color) => {
    if (activeColorField) {
      dispatch({ field: activeColorField, value: color });
    }
  }, [activeColorField, dispatch]);

  // Handler for toggling boolean values
  const handleToggle = useCallback((field) => () => {
    dispatch({ field, value: !state[field] });
  }, [state, dispatch]);

  // Handler for regenerating colors
  const handleRegenerateColors = useCallback((palette) => {
    dispatch({ field: 'regenerateColors', palette });
  }, [dispatch]);

  // Close color picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
        setActiveColorField(null);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="ControlCenter">
      <BuildingControlsLeft 
        handleChange={handleChange}
        handleToggle={handleToggle}
      />
      <BuildingControlsRight 
        handleChange={handleChange}
        handleToggle={handleToggle}
        handleColorChange={handleColorChange}
        handleRegenerateColors={handleRegenerateColors}
        activeColorField={activeColorField}
        setActiveColorField={setActiveColorField}
      />
    </div>
  );
});

export default ControlCenter;